import React from "react";
import { DescriptionPros } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function StarterDescWelcome() {
	return (
		<DescriptionPros>
			<span>
				<strong>Assine nossos planos e aproveite funcionalidades como:</strong>
			</span>
			<span>
				<FontAwesomeIcon icon={faCheck} style={{ color: "green" }} /> Cotação BMF & EUA
			</span>
			<span>
				<FontAwesomeIcon icon={faCheck} style={{ color: "green" }} /> Carteira completa
				com ativos internacionais
			</span>
			<span>
				<FontAwesomeIcon icon={faCheck} style={{ color: "green" }} /> Indicadores de
				Análise Fundamentalista, consenso e estimativas de empresas
			</span>
			<span>
				<FontAwesomeIcon icon={faCheck} style={{ color: "green" }} /> Hub de Notícias
				premium
			</span>
			<span>
				<FontAwesomeIcon icon={faCheck} style={{ color: "green" }} /> Prateleira
				completa de Renda Fixa
			</span>
			<span>E muito mais!</span>
			{/* <span>Confira todos os detalhes e se torne um assinante em:  <strong>trademap.com.br/planos</strong></span> */}
		</DescriptionPros>
	);
}
